import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import ThemePageData from "../Data/ThemePageData/ThemePageData";
import usePageMeta from "../Helpers/usePageMeta";

const ThemePreview = () => {
  const { id } = useParams();
  const location = useLocation();

  console.log("Loc URL", location.pathname.split("/")[2]);

  const [themeData, setThemeData] = useState({});

  const item = ThemePageData[id];

  // Preview pages are thin (an embedded Wix demo), so keep them out of search results.
  const previewName = item?.pageName || "Theme";
  usePageMeta({
    title: `Preview ${previewName} | TZ Creation`,
    description: `Live preview of the ${previewName} website theme from the TZ Creation Theme Store.`,
    noindex: true,
  });

  console.log("Current Item : ", item);

  useEffect(() => {
    if (id) {
      if (item) {
        setThemeData({
          previewUrl: item?.previewUrl,
          ThemeName: item?.pageName,
        });
      }
    }
  }, [id, item]);

  // console.log("+++++", pageContentProps?.FigmaDesignLink);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const QuickOrderMessage = `https://api.whatsapp.com/send/?phone=+971581765760&text=*Hello+TZ+Creation+Team*,+I+love+${themeData.ThemeName}+theme+for+my+project.+Send+me+details.`;

  return (
    <div style={{ color: "#777777", height: "100%" }}>
      <Header />
      <div className="ThemePreviewContainer">
        <div className="ThemeBackBar">
          <Link
            to="/theme-store"
            className="ThemeBackLink"
            aria-label="Back to all themes"
          >
            &larr; All Themes
          </Link>
        </div>
        <div className="ThemeStickyButton">
          <a
            href={QuickOrderMessage}
            className="chat_wrap liveChat text-center"
            style={{
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Quick Start Now
          </a>
        </div>

        <iframe
          title={themeData?.ThemeName}
          style={{
            border: "1px solid rgba(0, 0, 0, 0.1)",
            width: "100%",
            height: "calc(100vh - 90px)",
          }}
          className="Theme-Preview"
          src={themeData?.previewUrl}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default ThemePreview;
